import { BaseLayout } from "./components";
import { ContractorDashboard, ContractorList, CreateContractor, EditContractor } from "./contractors";
import { CreateProject, EditProject, ProjectDashboard, ProjectList } from "./projects";
import { CreateScope, EditScope, ScopeOfWorkList } from "./scopeOfWork";
import { CreateTestEvent, EditTestEvent, TestEventList, TestResults } from "./testEvents";
import { CreateWelder, EditWelder, WelderDashboard, WelderList } from "./welders";
import { Dashboard } from "./dashboard";
import { GlobalSearch } from "./search";
import { HelpPage, SettingsPage } from "./settings";
import { HomePage } from "./home/HomePage";
import { NotFound } from "@/components";
import { OwnershipTransfer } from "./users";
import { RequestForm, StandardTestsList } from "./standardTests";
import { Route, Routes } from "react-router";
import { routes } from "./routes";
import { SpecialistTransfer } from "./users/transfer/specialist/Index";
import { VersionCheck } from "@/components/guards";
import { WelderRenewal } from "./renewals";
import { WeldingSpecialists } from "./settings/WeldingSpecialists";

export default () => (
  <Routes>
    <Route element={<VersionCheck version="Williams" />}>
      <Route element={<BaseLayout />}>
        <Route index element={<HomePage />} />

        {/* Dashboard */}
        <Route path={routes.dashboard.view(":view?")} element={<Dashboard />} />
        {/* Projects */}
        <Route path={routes.project.list} element={<ProjectList />} />
        <Route path={routes.project.create} element={<CreateProject />} />
        <Route path={routes.project.open(":id")} element={<ProjectDashboard />} />
        <Route path={routes.project.edit(":id")} element={<EditProject />} />
        {/* Scope of Work */}
        <Route path={routes.scopeOfWork.list(":view?")} element={<ScopeOfWorkList />} />
        <Route path={routes.scopeOfWork.create} element={<CreateScope />} />
        <Route path={routes.scopeOfWork.open(":id")} element={<EditScope />} />
        {/* Test Events */}
        <Route path={routes.testEvent.list} element={<TestEventList />} />
        <Route path={routes.testEvent.create} element={<CreateTestEvent />} />
        <Route path={routes.testEvent.open(":id")} element={<EditTestEvent />} />
        <Route path={routes.testEvent.results(":id")} element={<TestResults />} />
        {/* Welders */}
        <Route path={routes.welder.list(":view?")} element={<WelderList />} />
        <Route path={routes.welder.create} element={<CreateWelder />} />
        <Route path={routes.welder.open(":id")} element={<WelderDashboard />} />
        <Route path={routes.welder.edit(":id")} element={<EditWelder />} />
        <Route path={routes.welder.renewal} element={<WelderRenewal />} />
        {/* Contractors */}
        <Route path={routes.contractor.list} element={<ContractorList />} />
        <Route path={routes.contractor.create} element={<CreateContractor />} />
        <Route path={routes.contractor.open(":id")} element={<ContractorDashboard />} />
        <Route path={routes.contractor.edit(":id")} element={<EditContractor />} />
        {/* Standard Tests */}
        <Route path={routes.standardTests.list} element={<StandardTestsList />} />
        <Route path={routes.standardTests.create} element={<RequestForm />} />
        <Route path={routes.standardTests.open(":id")} element={<StandardTestsList />} />
        {/* User */}
        <Route path={routes.user.transferOwnership} element={<OwnershipTransfer />} />
        <Route path={routes.user.transferSpecialist} element={<SpecialistTransfer />} />
        {/* Miscellaneous */}
        <Route path={routes.miscellaneous.help} element={<HelpPage />} />
        <Route path={routes.miscellaneous.settings} element={<SettingsPage />} />
        <Route path={routes.miscellaneous.search} element={<GlobalSearch />} />
        <Route path={routes.miscellaneous.weldingSpecialists} element={<WeldingSpecialists />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>
  </Routes>
);
